export enum AdminMultimediaListItemAction {
  Copy,
  Download,
  More,
  Preview,
  Remove,
}
